class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopup=true");

    const justSubscribed = !!this.popup.querySelector(".form__success-field");
    const hasError = !!this.popup.querySelector(".form__error-field");

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (event) => {
        event.preventDefault();
        this.popup.classList.add("hidden");
        if (!justSubscribed) this.setCookie("hideNotificationPopup", "true", 7);
      });
    }

    // Just signed up: show the discount code straight away, then never show the popup again.
    if (justSubscribed) {
      this.setCookie("hideNotificationPopup", "true", 365);
      this.show();
      return;
    }

    // Signup failed (e.g. invalid email): reopen straight away so they can see the message.
    if (hasError) {
      this.show();
      return;
    }

    if (this.hasSubscription || this.cookie) return;

    setTimeout(() => this.show(), this.delay * 1000);
  }

  show() {
    this.popup.classList.remove("hidden");
    this.popup.classList.add("wt-popup-fade-in");
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup", NotificationPopup);
